export default __webpack_public_path__ + "static/media/vitalik_nft_19.ca7ad366.svg";